import styled from 'styled-components';
import Button from '../button/Button.component'
import { IButton } from '../button/interface/Button.interface';

const ButtonFinish = styled(Button)`
  color: #fff;
  border-radius: 4px;
  box-shadow: 0px 2px 4px rgba(77, 139, 255, 0.3);
  :disabled {
    background-color:rgba(0,0,0,0.1);
    color: #fff;
    cursor: not-allowed;
  }
  :disabled:hover {
    background-color:rgba(0,0,0,0.1);
    color: #fff;
    cursor: not-allowed;
  }
  ${({ actived }: IButton) => (actived) ?
    ":hover { background-color: #095aa5; color: #fff; }" :
    ":hover { background-color: #ff690a; color: #fff; }"
  }
  font-size: ${({fontSize}: IButton) => (fontSize) ? '22px' : '18px'};
  background-color: ${({ actived }: IButton) => actived ? '#ff690a' : '#095aa5'};
  margin: ${({margin}: IButton) => (margin) ? "45px 0px 0px 0px" : "0px"}
`;

export default ButtonFinish;
